import {
  cashDrawerPosModule,
  orderHubPosModule,
  paymentPosModule,
  tableLayoutPosModule,
} from '../PosModules/moduleFeatures';

export const defaultBartenderPermission = [
  {
    id: 510,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 511,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: null,
    key: 'my-restaurant-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 512,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 513,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 514,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 515,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 516,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 517,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 518,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 519,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 520,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: null,
    key: 'docvault-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 521,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 522,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 523,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 524,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 525,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 526,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 527,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 528,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 529,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 530,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 531,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 532,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 533,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 534,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 535,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 536,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 537,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 538,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 539,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 540,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 541,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 542,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 543,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 544,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 545,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 546,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 547,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 548,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 549,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 550,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 551,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 552,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 553,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 554,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 555,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 31,
    key: 'own-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 556,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 557,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 34,
    key: 'release-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 558,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 559,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 118,
    key: 'release-manager-approval-required-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 560,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 119,
    key: 'bid-on-open-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 561,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 562,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 563,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 86,
    key: 'can-be-assigned-a-task-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 564,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 565,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 566,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 567,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 568,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 569,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 570,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 571,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 572,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 573,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 574,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 575,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 576,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 577,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 578,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 579,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 580,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 581,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 582,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 583,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 584,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 585,
    roleId: 8,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 586,
    roleId: 8,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 587,
    roleId: 8,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 588,
    roleId: 8,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 589,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 590,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 132,
    key: 'view-own-paystubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1354,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1355,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1356,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1357,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1358,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1359,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: null,
    key: 'header-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1360,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1361,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: null,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1362,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1363,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1364,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1365,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1366,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 48,
    key: 'table-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1367,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 49,
    key: 'switch-floors-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1368,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 50,
    key: 'view-seating-capacity-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1369,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1370,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 55,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1371,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 56,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1372,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1373,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1374,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1375,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1376,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1377,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 62,
    key: 'settings-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1378,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 63,
    key: 'orders-hub-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1379,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 64,
    key: 'restaurant-type-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1380,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 65,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1381,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 66,
    key: 'aio-help-center-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1382,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 67,
    key: 'my-day-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1383,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 72,
    key: 'my-station-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1384,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 73,
    key: 'host-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1385,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 74,
    key: 'logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1386,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 75,
    key: 'adjust-starting-balance-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1387,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 76,
    key: 'close-drawer-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1388,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1389,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1390,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1607,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1608,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1609,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1610,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1611,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1612,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1613,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 78,
    key: 'other-tables-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1614,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1615,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 79,
    key: 'void-items-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1616,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 80,
    key: 'edit-service-charge-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1617,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1618,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1619,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1620,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1621,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1622,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 81,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3461,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3464,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 17,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3468,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3480,
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];
export const bartenderDefaultPosPermission = [
  tableLayoutPosModule['assign-server-visible'],
  paymentPosModule['tenders-visible-is-approval-needed'],
  orderHubPosModule['order-hub-visible'],
  orderHubPosModule['ticket-visible-is-approval-needed'],
  cashDrawerPosModule['other-stations-visible'],
];
